import { TGetExamDetailDto } from "@/api/services/main/learning-progress/dtos/exam/get-exam-detail-by-industry.dto";
import { black, state, text } from "@/theme/colors";
import { OpenInNew } from "@mui/icons-material";
import { Stack, styled, Typography } from "@mui/material";
import { FC } from "react";

export const ExamLinksTab: FC<{ exam: TGetExamDetailDto | null }> = ({ exam }) => {
  return (
    <Stack gap={1}>
      {exam?.relatedLinks && exam.relatedLinks.length > 0 ? (
        exam.relatedLinks.map((link) => (
          <Stack key={link.id} flexDirection="row" gap={2} px={1.5} alignItems="center">
            <StyledDot />
            <StyledExternalLink href={link.url} target="_blank" rel="noopener noreferrer">
              <Stack direction="row" alignItems="center" gap={0.5}>
                <Typography variant="body14" color={state.link_1}>
                  {link.label}
                </Typography>
                <OpenInNew sx={{ fontSize: 16, color: state.link_1 }} />
              </Stack>
            </StyledExternalLink>
          </Stack>
        ))
      ) : (
        <Typography variant="body14" color={text.tertiary}>
          関連リンク情報がありません。
        </Typography>
      )}
    </Stack>
  );
};

const StyledExternalLink = styled("a")({
  textDecoration: "none",
});

const StyledDot = styled(Stack)(() => ({
  width: 10,
  height: 10,
  borderRadius: "50%",
  backgroundColor: black[80],
}));
